/* This example requires Tailwind CSS v2.0+ */
import { Listbox, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import dynamic from 'next/dynamic';

import RangeSlider from '../RangeSlider/RangeSlider';
import { useSelector } from 'react-redux';

const AiOutlineDown = dynamic(() =>
  import('react-icons/ai').then((mod) => mod.AiOutlineDown)
);

export default function CustomDropdownForRangeSlider({
  selected,
  setSelected,
  label,
  width,
  age,
  setAge,
  showAgeSlider,
  setShowAgeSlider,
  setApplyAgeFilter,
  min,
  max,
  title,
}) {
  // const [value, setValue] = useState([18, 100]);

  const handleSliderOpen = () => {
    setShowAgeSlider(!showAgeSlider);
    setApplyAgeFilter(false);
  };

  const handleSliderCancel = () => {
    setShowAgeSlider(false);
    setApplyAgeFilter(false);
  };

  const handleOk = () => {
    setShowAgeSlider(false);
    setApplyAgeFilter(true);
  };

  const lang = useSelector(({ common }) => common?.language);

  return (
    <Listbox value={selected} onChange={setSelected}>
      {({ open }) => (
        <>
          {/* <Listbox.Label className="block text-sm font-bold text-gray-700">
            Change Your City
          </Listbox.Label> */}
          <div className='relative rounded-full bg-white'>
            <Listbox.Button
              onClick={handleSliderOpen}
              className='relative h-[48px] w-full    cursor-default rounded-full  border border-[#DBD9D9] bg-transparent py-2 pl-6 pr-10 text-left focus:border-gray-500   focus-visible:outline-none sm:text-sm'
            >
              <span className='flex items-center'>
                {/* {selected && <MdLocationPin className="text-xl text-black" />} */}
                <span className='block truncate text-[14px]'>
                  {selected ? (
                    selected.name
                  ) : (
                    <p className='block pt-[4px] text-[14px] text-black'>
                      {label}
                    </p>
                  )}
                </span>
              </span>
              <span className='pointer-events-none absolute inset-y-0 right-0 mx-3 flex items-center pt-[2px]'>
                <AiOutlineDown
                  className='h-3 w-3 text-[#323232]'
                  aria-hidden='true'
                />
              </span>
            </Listbox.Button>
            {showAgeSlider && (
              <Transition
                show={open || showAgeSlider}
                as={Fragment}
                leave='transition ease-in duration-100'
                leaveFrom='opacity-100'
                leaveTo='opacity-0'
              >
                <Listbox.Options
                  className={`${width} absolute z-10 mt-2 w-full rounded-md bg-white px-10  pt-10 text-base shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none  sm:w-[350px] sm:text-sm`}
                >
                  <p className='pb-4 text-center text-lg'>{title}</p>
                  <div className='pb-2'>
                    <RangeSlider
                      value={age}
                      setValue={setAge}
                      min={min}
                      max={max}
                    />
                  </div>

                  <div className='flex justify-between pb-10 pt-4'>
                    <button
                      onClick={handleSliderCancel}
                      className='rounded px-4 py-2 font-bold'
                    >
                      {lang?.common?.cancel}
                    </button>
                    <button
                      onClick={handleOk}
                      className='rounded border-2 border-black px-4 py-2 font-bold uppercase'
                    >
                      {lang?.common?.ok}
                    </button>
                  </div>
                </Listbox.Options>
              </Transition>
            )}
          </div>
        </>
      )}
    </Listbox>
  );
}
